/**
 * MFEBus — lightweight pub/sub event bus for cross-MFE communication.
 * All micro frontends share this singleton without tight coupling.
 */
const MFEBus = (() => {
  const ch      = new Map()   // event → Set<handler>
  const _log    = []          // rolling 22-entry event log
  const _logCbs = new Set()   // log-change subscribers

  function on(event, fn) {
    if (!ch.has(event)) ch.set(event, new Set())
    ch.get(event).add(fn)
    return () => ch.get(event)?.delete(fn)   // returns unsubscribe fn
  }

  function emit(event, payload = {}) {
    const ts = new Date().toLocaleTimeString('en-AU', { hour12: false })
    _log.unshift({ event, payload, ts })
    if (_log.length > 22) _log.pop()
    _logCbs.forEach(cb => cb([..._log]))
    ch.get(event)?.forEach(fn => fn(payload))
    ch.get('*')?.forEach(fn => fn({ event, payload }))  // wildcard listener
  }

  function onLog(cb) { _logCbs.add(cb); return () => _logCbs.delete(cb) }

  return { on, emit, onLog, _log }
})()

export default MFEBus
